<template>
	<right-panel :datas="connects" ref="rightPanel" @onClose="onCloseChange()">
		<div slot="header">
			<translate>Log Detail</translate>
		</div>
		<div slot="content" class="wrapper-padding">
			<div class="alarmLogDetail" v-if="connects">
				<el-row type="flex">
					<el-col :span="10" class="view-right"><translate>Operation Time</translate><span>:</span></el-col>
					<el-col :span="10">{{ connects.operation_time }}</el-col>
				</el-row>
				<el-row type="flex">
					<el-col :span="10" class="view-right"><translate>Users</translate><span>:</span></el-col>
					<el-col :span="10">{{ connects.account_name }}</el-col>
				</el-row>
				<el-row type="flex">
					<el-col :span="10" class="view-right"><translate>Source IP</translate><span>:</span></el-col>
					<el-col :span="10">{{ connects.con_ip }}</el-col>
				</el-row>
				<el-row type="flex">
					<el-col :span="10" class="view-right"><translate>Operation Obj</translate><span>:</span></el-col>
					<el-col :span="10">{{ connects.resource_name }}</el-col>
				</el-row>
				<el-row type="flex">
					<el-col :span="10" class="view-right"><translate>In Work Group</translate><span>:</span></el-col>
					<el-col :span="10">{{ connects.project_name }}</el-col>
				</el-row>
				<el-row type="flex">
					<el-col :span="10" class="view-right"><translate>Connect Type</translate><span>:</span></el-col>
					<el-col :span="10">{{ connects.way }}</el-col>
				</el-row>
				<el-row type="flex">
					<el-col :span="10" class="view-right"><translate>Trigger Strategy</translate><span>:</span></el-col>
					<el-col :span="10">{{ connects.match_command }}</el-col>
				</el-row>
				<el-row type="flex">
					<el-col :span="10" class="view-right"><translate>Event Desc</translate><span>:</span></el-col>
					<el-col :span="10">{{ connects.command }}</el-col>
					<el-col :span="3">
						<img v-clipboard:copy="connects.command" v-clipboard:success="copySuccess" style="width: 17px; cursor: pointer" src="../../../../static/images/apply/copy.png" alt="" />
					</el-col>
				</el-row>
				<el-row type="flex">
					<el-col :span="10" class="view-right"><translate>Notify Obj</translate><span>:</span></el-col>
					<el-col :span="10">
						<div v-if="connects.notice_accounts">
							<p v-for="i in JSON.parse(connects.notice_accounts)" :key="i">{{ i }}</p>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div slot="footer" class="detail-btn">
			<div class="btn-wrapper"></div>
		</div>
	</right-panel>
</template>

<script>
import { SelectOptionsConfig } from '../../../config'
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'

export default {
	name: 'CreateEventNotice',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	created() {},
	methods: {
		// 提取翻译文本
		getTranslateText() {
			return {
				eventType: this.$gettext('Event Type'),
				notifyObj: this.$gettext('Notify Obj'),
			}
		},

		copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success',
			})
		},

		onCloseChange() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
				console.log(this.connects, 'this.connects')
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
.alarmLogDetail {
	padding: 15px;
	.el-col {
		word-wrap: break-word;
	}
	.el-col-8 {
		text-align: right;
	}
	.el-row {
		padding-top: 10px;
		padding-bottom: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// alarm-log-detail.vue?ea1951fc